import React from 'react'
import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'
import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import Select from 'react-select'

import useViewModel from './ViewModel'
import clsx from 'clsx'

const MachineFormView: React.FC = () => {
  const {
    typeOptions,
    isCreate,
    isLoading,
    isSubmitting,
    formState,
    formError,
    onChangeFormState,
    onSubmit,
    onCancel,
  } = useViewModel()

  return (
    <ViewPageTitle isCreate={isCreate} title={formState.brand}>
      <div className='mb-5'>
        <PageBreadCrumb />
      </div>

      <div className='card border border-2'>
        {/* begin:: Header */}
        <div className='card-header'>
          <div className='card-title fw-bold'></div>
          <div className='card-toolbar'>
            <button className='btn btn-sm btn-secondary fw-bold me-4' onClick={onCancel}>
              ยกเลิก
            </button>
            <button
              className='btn btn-sm btn-primary fw-bold'
              onClick={onSubmit}
              disabled={isLoading || isSubmitting}>
              บันทึก
            </button>
          </div>
        </div>

        <div className='card-body'>
          <div className='row gy-3'>
            <div className='col-12 col-xl-4'>
              <label className='mb-2'>
                ชื่อเครื่องจักร (Brand) <span className='required' />
              </label>
              <input
                type='text'
                className={clsx('form-control form-control-sm', {
                  'is-invalid': formError.brand,
                })}
                value={formState.brand}
                onChange={(e: any) => onChangeFormState('brand', e.target.value)}
              />
            </div>

            <div className='col-12 col-xl-4'>
              <label className='mb-2'>
                รุ่นเครื่องจักร (Machine Model) <span className='required' />
              </label>
              <input
                type='text'
                className={clsx('form-control form-control-sm', {
                  'is-invalid': formError.machineModel,
                })}
                value={formState.machineModel}
                onChange={(e: any) => onChangeFormState('machineModel', e.target.value)}
              />
            </div>

            <div className='col-12 col-xl-4'>
              <label className='mb-2'>
                รหัสเครื่องจักร (Machine Code) <span className='required' />
              </label>
              <input
                type='text'
                className={clsx('form-control form-control-sm', {
                  'is-invalid': formError.machineCode,
                })}
                value={formState.machineCode}
                onChange={(e: any) => onChangeFormState('machineCode', e.target.value)}
              />
            </div>

            <div className='col-12 col-xl-6'>
              <label className='mb-2'>
                ประเภทเครื่องจักร (Machine Type) <span className='required' />
              </label>
              <Select
                isMulti={false}
                styles={{
                  control: (provided: any) => ({
                    ...provided,
                    borderColor: formError.jobStatus ? 'red' : '#e1e3ea',
                  }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                options={typeOptions}
                value={typeOptions.find(option => option.value === formState.machineTypeID) ?? null}
                onChange={(option: any) => onChangeFormState('machineTypeID', option.value)}
              />
            </div>

            <div className='col-12 col-xl-6'>
              <label className='mb-2'>ระบบการตอก</label>
              <input
                type='text'
                className={clsx('form-control form-control-sm', {
                  'is-invalid': formError.pillingType,
                })}
                value={formState.pillingType}
                onChange={(e: any) => onChangeFormState('pillingType', e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren & { isCreate: boolean; title?: string }> = ({
  children,
  isCreate,
}) => {
  const headerText = isCreate ? 'เพิ่มเครื่องจักร' : `แก้ไขเครื่องจักร​`

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: false,
            isSeparator: false,
            path: '/machine',
            title: 'รายการทั้งหมด',
            icon: '/media/icons/duotune/files/fil024.svg',
          },
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: 'เครื่องจักร',
            icon: '/media/icons/duotune/files/fil024.svg',
          },
        ]}>
        {headerText}
      </PageTitle>

      {children}
    </>
  )
}

export default MachineFormView
